/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "542")
  

// 接口文档

  
    
export interface IAPI75078ReqTaskListItem {
  
  /**  */
  taskTitle?: string;
  
  /**  */
  taskDesc?: string;
  
  /** String */
  taskExecutorIdList?: string[];
  
  /**  */
  startTime?: any;
  
  /**  */
  endTime?: any;
  
  /**  */
  bizDomain?: number;
  
  /**  */
  bizType?: string;
  
  /**  */
  bizNo?: string;
  
  /**  */
  creator?: string;
  
  /**  */
  creatorName?: string;
  
  /**  */
  taskCode?: string;
  
  /**  */
  taskStatus?: number;
  
};
    
  
    
export interface IAPI75078ResRecordsItemActionsItem {
  
  /**  */
  label?: string;
  
  /**  */
  value?: string;
  
  /**  */
  isSelect?: boolean;
  
};
    
  
    
export type IAPI75078ResRecordsItemOtherDataObjMapValueObj = {};
    
  
    
export interface IAPI75078ResRecordsItemOtherDataObj {
  
  /** String */
  mapKey?: IAPI75078ResRecordsItemOtherDataObjMapKeyObj;
  
  /** Object */
  mapValue?: IAPI75078ResRecordsItemOtherDataObjMapValueObj;
  
};
    
  
    
export interface IAPI75078ResRecordsItemTreeDataItem {
  
  /** 节点名称 */
  nodeName?: string;
  
  /** 岗位名称 */
  jobName?: string;
  
};
    
  
    
export interface IAPI75078ResRecordsItem {
  
  /**  */
  id?: string;
  
  /**  */
  sendTime?: string;
  
  /**  */
  content?: string;
  
  /**  */
  source?: string;
  
  /** ActionResp */
  actions?: IAPI75078ResRecordsItemActionsItem[];
  
  /**  */
  timesTotal?: number;
  
  /**  */
  timesLeft?: number;
  
  /**  */
  isLine?: boolean;
  
  /** (该参数为map) */
  otherData?: IAPI75078ResRecordsItemOtherDataObj;
  
  /** TreeNodeResult */
  treeData?: IAPI75078ResRecordsItemTreeDataItem[];
  
};
    
  
    
export interface IAPI75078ResFromObj {
  
  /**  */
  userType?: string;
  
  /**  */
  headImg?: string;
  
  /**  */
  nickName?: string;
  
  /**  */
  realName?: string;
  
  /**  */
  userId?: string;
  
};
    
  
    
export interface IAPI75078ResToObj {
  
  /**  */
  userType?: string;
  
  /**  */
  headImg?: string;
  
  /**  */
  nickName?: string;
  
  /**  */
  realName?: string;
  
  /**  */
  userId?: string;
  
};
    
  



export interface API75078Req {
  
  /** 会话标识Id */
  sessionToken?: string;
  /** 会议纪要内容 ,TaskAddDTO */
  taskList?: IAPI75078ReqTaskListItem[];
};



export interface API75078Res {
  /** 会话标识Id  */
  sessionToken?: string;
  /** 会话记录 ,ChatRecordResp  */
  records?: IAPI75078ResRecordsItem[];
  /** 用户信息 ,ChatUserResult  */
  from?: IAPI75078ResFromObj;
  /** 用户信息 ,ChatUserResult  */
  to?: IAPI75078ResToObj;
  /** 是否有聊天时间true：可以发送消息false:不可以发送  */
  hasChatTime?: boolean;
  /** 聊天时长提示true:提示，并显示兑换按钮false：不提示  */
  chatTimeTips?: boolean;
  
};


// 接口函数 75078 发起任务

export interface IUsePostAPI75078Return {
  /** 发起任务: 接口请求状态 */
  isAPI75078Loading: boolean;
  /** 发起任务: 接口请求返回数据 */
  dataAPI75078: API75078Res;
  /**  发起任务: 接口数据请求方法 */
  fetchAPI75078Data: (inputs: API75078Req, config?: YWRequestConfig) => Promise<API75078Res>;
  /** 发起任务: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI75078 = ():IUsePostAPI75078Return => {
  let isMount = true;
  const [isAPI75078Loading, setIsAPI75078Loading] = useState(false);
  const [dataAPI75078, setDataAPI75078] = useState<API75078Res>({} as API75078Res);
  const requestUrl = `${basePath}/yoaichat-web/chat/meeting/task/execute`;

  const fetchAPI75078Data = async (inputs: API75078Req, config?: YWRequestConfig): Promise<API75078Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API75078Req>) || {}) as API75078Req;
    
  
    if ( isMount ) {
      setIsAPI75078Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API75078Res>(`${basePath}/yoaichat-web/chat/meeting/task/execute`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI75078(res || {} as API75078Res);
        setIsAPI75078Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI75078Loading(false);
      }
      return false as unknown as API75078Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI75078Loading,
    dataAPI75078,
    fetchAPI75078Data,
    requestUrl,
  }
}

